import { Search } from 'lucide-react';

/* Modals extracted from ProjectDetails.js — strictly preserve existing behavior/ids. */

export const AddCharactersModal = ({ open, onClose, charactersText, setCharactersText, onSubmit }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-slate-800 rounded-xl p-6 w-full max-w-md border border-slate-700 my-auto max-h-[calc(100vh-2rem)] overflow-y-auto">
        <h2 className="text-xl font-bold text-white mb-4">Adicionar Personagens</h2>
        <p className="text-slate-400 text-sm mb-2">Use TAB para separar: <span className="text-teal-400 font-mono">PERSONAGEM[TAB]DUBLADOR[TAB]FALAS</span></p>
        <p className="text-slate-500 text-xs mb-4">Cole direto de uma planilha ou digite com TAB. Sem TAB, a linha inteira é o nome do personagem.</p>
        <form onSubmit={onSubmit}>
          <textarea
            value={charactersText}
            onChange={e => setCharactersText(e.target.value)}
            className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-teal-500 h-48 font-mono"
            placeholder={"JULIO MICKA 89\nMARIA AMANDA 45\nCARLOS\nSUELI BRUNA 30"}
            data-testid="characters-text-input"
          />
          <div className="flex gap-3 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-lg transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="flex-1 bg-teal-500 hover:bg-teal-600 text-white py-2 rounded-lg transition-colors"
              data-testid="submit-characters-btn"
            >
              Adicionar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const ModifyCharactersModal = ({ open, onClose, modifyText, setModifyText, onSubmit }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-slate-800 rounded-xl p-6 w-full max-w-md border border-slate-700 my-auto max-h-[calc(100vh-2rem)] overflow-y-auto">
        <h2 className="text-xl font-bold text-white mb-2">Modificar Personagens</h2>
        <p className="text-slate-400 text-sm mb-1">Use TAB para separar: <span className="text-amber-400 font-mono">PERSONAGEM[TAB]DUBLADOR[TAB]FALAS</span></p>
        <p className="text-slate-500 text-xs mb-4">Cole direto de uma planilha. Múltiplos dubladores separados por "/".</p>
        <form onSubmit={onSubmit}>
          <textarea
            value={modifyText}
            onChange={e => setModifyText(e.target.value)}
            className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-amber-500 h-48 font-mono"
            placeholder={"OLIVIA SOUZA ZIZIBS 60\nJULIO MICKA 89\nCARLOS HENRY 30"}
            data-testid="modify-text-input"
          />
          <div className="flex gap-3 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-lg transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="flex-1 bg-amber-500 hover:bg-amber-600 text-white py-2 rounded-lg transition-colors"
              data-testid="submit-modify-btn"
            >
              Modificar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const EditCharacterModal = ({
  character, onClose, userSearch, setUserSearch,
  selectedUserId, setSelectedUserId, filteredUsers, onSave,
}) => {
  if (!character) return null;
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-slate-800 rounded-xl p-6 w-full max-w-md border border-slate-700 my-auto max-h-[calc(100vh-2rem)] overflow-y-auto">
        <h2 className="text-xl font-bold text-white mb-4">
          Editar: {character.name}
        </h2>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-2">Atribuir Dublador</label>
            <div className="relative mb-2">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <input
                type="text"
                value={userSearch}
                onChange={e => setUserSearch(e.target.value)}
                placeholder="Buscar dublador..."
                className="w-full bg-slate-700 border border-slate-600 rounded-lg pl-10 pr-4 py-2 text-white focus:outline-none focus:border-teal-500"
              />
            </div>
            <select
              value={selectedUserId}
              onChange={e => setSelectedUserId(e.target.value)}
              className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-teal-500"
              data-testid="assign-user-select"
            >
              <option value="">-- Nenhum --</option>
              {filteredUsers.map(u => (
                <option key={u.id} value={u.id}>
                  {u.artist_name || u.name} ({u.email})
                </option>
              ))}
            </select>
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-lg transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={onSave}
              className="flex-1 bg-teal-500 hover:bg-teal-600 text-white py-2 rounded-lg transition-colors"
              data-testid="save-character-btn"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ReplaceRequestModal = ({
  open, onClose, myAssignedChars, replaceMotivo, setReplaceMotivo, onSubmit,
}) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-slate-800 rounded-xl p-6 w-full max-w-md border border-slate-700 my-auto max-h-[calc(100vh-2rem)] overflow-y-auto"
        onClick={e => e.stopPropagation()}
        data-testid="replace-modal"
      >
        <h2 className="text-xl font-bold text-white mb-2">Solicitar Substituição</h2>
        <p className="text-sm text-slate-400 mb-4">
          Isso envia uma notificação para os administradores. Seus personagens neste projeto:
        </p>
        <div className="bg-slate-900/70 border border-slate-700 rounded-lg p-3 mb-4 max-h-40 overflow-y-auto">
          <ul className="space-y-1">
            {myAssignedChars.map(c => (
              <li key={c.id} className="text-sm text-slate-200">• {c.name}</li>
            ))}
          </ul>
        </div>
        <label className="block text-sm text-slate-300 mb-1">Motivo (opcional)</label>
        <textarea
          value={replaceMotivo}
          onChange={e => setReplaceMotivo(e.target.value)}
          placeholder="Ex: estou sem voz, viagem inesperada, etc."
          className="w-full bg-slate-700 border border-slate-600 rounded-lg px-3 py-2 text-white focus:outline-none focus:border-teal-500 text-sm"
          rows={3}
          data-testid="replace-motivo"
        />
        <div className="flex gap-2 mt-4">
          <button
            onClick={onClose}
            className="flex-1 bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-lg transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={onSubmit}
            className="flex-1 bg-amber-600 hover:bg-amber-700 text-white py-2 rounded-lg transition-colors font-medium"
            data-testid="replace-submit"
          >
            Enviar Solicitação
          </button>
        </div>
      </div>
    </div>
  );
};
